(function() {
  'use strict';

  angular.module('app').factory('GoodsService', GoodsService);

  GoodsService.$inject = ['$rootScope', 'API', 'NotifyService'];

  function GoodsService($rootScope, API, NotifyService) {
    var service = {};
    /**
     * This callback type is called `requestCallback` and is displayed as a global symbol.
     *
     * @callback requestCallback
     * @param {boolean} success
     * @param {Object} data
     */
    /**
     * @typedef MultiLanguageObject
     * @type {Object}
     * @property {string} en - String on English
     * @property {string} pl - String on Polish
     * @property {string} ru - String on Russian
     * @property {string} uk - String on Ukrainian
     */
    initVars();

    function initVars() {
      $rootScope.GOODS = {};
      $rootScope.GOODS_CATEGORIES = {};
    }

    $rootScope.$on('user-login', function() {
      initVars();
    });

    $rootScope.$on('user-register', function() {
      initVars();
    });

    $rootScope.$on('user-logout', function() {
      $rootScope.GOODS_ALL = null;
      $rootScope.GOODS = null;
      $rootScope.GOODS_CATEGORIES = null;
    });

    // =========================================  Goods CATEGORIES  ================================================

    /**
     * Return categories tree
     *
     * @param loyaltyID - Loyalty ID
     * @param params - Params
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.Categories = function(loyaltyID, params, callback) {
      if (!$rootScope.GOODS_CATEGORIES)
        $rootScope.GOODS_CATEGORIES = [];

      var url = '/goods/categories/{0}?{1}'.format(loyaltyID, paramsToUrlQueryEncodeURIComponent(params));
      API.get(url, function(success, data) {
        if (success) {
          $rootScope.GOODS_CATEGORIES[loyaltyID] = data;
        }
        callback(success, data);
      });
    };

    /**
     * Modify categories tree
     * @param loyaltyId - loyalty Id
     * @param post_data - post data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.CategoriesEdit = function(loyaltyId, post_data, callback) {
      if (!$rootScope.GOODS_CATEGORIES)
        $rootScope.GOODS_CATEGORIES = [];

      API.patch('/goods/categories/{0}'.format(loyaltyId), post_data, function(success, data) {
        if (success) {
          $rootScope.GOODS_CATEGORIES[loyaltyId] = data;
        }
        callback(success, data);
      });
    };

    /**
     * Return category
     * @param categoryId - Category Id
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.Category = function(categoryId, callback) {
      if (!$rootScope.GOODS_CATEGORIES)
        $rootScope.GOODS_CATEGORIES = [];

      API.get('/goods/category/{0}'.format(categoryId), function(success, data) {
        if (success) {
          updateItemInList($rootScope.GOODS_CATEGORIES[data.loyalty_id], data);
        }
        callback(success, data);
      });
    };

    /**
     * Add new category
     * @param loyalty_id - loyalty Id
     * @param post_data - post data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.CategoryAdd = function(loyalty_id, post_data, callback) {
      if (!$rootScope.GOODS_CATEGORIES)
        $rootScope.GOODS_CATEGORIES = [];

      API.post('/goods/categories/{0}'.format(loyalty_id), post_data, function(success, data) {
        if (success) {
          updateItemInList($rootScope.GOODS_CATEGORIES[data.loyalty_id], data);
        }
        callback(success, data);
      });
    };

    /**
     * Modify category
     *
     * @param categoryId - Category Id
     * @param post_data - post data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.CategoryEdit = function(categoryId, post_data, callback) {
      if (!$rootScope.GOODS_CATEGORIES)
        $rootScope.GOODS_CATEGORIES = [];

      API.patch('/goods/category/{0}'.format(categoryId), post_data, function(success, data) {
        if (success) {
          updateItemInList($rootScope.GOODS_CATEGORIES[data.loyalty_id], data);
        }
        callback(success, data);
      });
    };

    /**
     * Upload category photo
     *
     * @param {string} categoryId - Category ID
     * @param data - data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UploadCategoryPhoto = function(categoryId, data, callback) {
      API.postImage('/goods/category/{0}/photo'.format(categoryId), data, function(success, response) {
        callback(success, response);
      });
    };

    /**
     * Delete/Clear goods category photo
     *
     * @param {string} categoryId - Category ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeleteCategoryPhoto = function(categoryId, callback) {
      API.delete('/goods/category/{0}/photo'.format(categoryId), null, function(success, response) {
        callback(success, response);
      });
    };

    // ==================================================  GOODS  ==================================================

    /**
     *
     * @param loyalty_id
     * @param params
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GoodsInLoyalty = function(loyalty_id, params, callback) {
      var url = '/goods/in_loyalty/{0}?{1}'.format(loyalty_id, paramsToUrlQueryEncodeURIComponent(params));
      API.get(url, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return goods in loyalty (root category) or Category
     *
     * @param {string} loyalty_id
     * @param {object} params
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GoodsInCategory = function(loyalty_id, params, callback) {
      var url = '/goods/in_category/{0}?{1}'.format(loyalty_id, paramsToUrlQueryEncodeURIComponent(params));
      API.get(url, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Return goods in loyalty (root category) or Category
     *
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GoodsInBusiness = function(callback) {
      var url = '/goods/in_business?service_type=all';

      API.get(url, function(success, data) {
        if (success) {
          $rootScope.GOODS_ALL = data;
        }
        callback(success, data);
      });

    };
    service.GoodsFuelInBusiness = function(callback) {
      var url = '/goods/in_business?service_type=fuel';

      API.get(url, function(success, data) {
        callback(success, data);
      });
    };

    /**
     * Store goods order in loyalty
     *
     * @param {string} loyalty_id
     * @param {string} categoryId
     * @param post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GoodsStoreOrder = function(loyalty_id, categoryId, post_data, callback) {
      var url = '/goods/in_category/{0}'.format(loyalty_id);
      if (categoryId) url = '{0}?category={1}'.format(url, categoryId);
      API.patch(url, post_data, function(success, data) {
        callback(success, data);
      });
    };

    /**
     *
     * @param {string} goodsId - Goods ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.Goods = function(goodsId, callback) {
      API.get('/goods/{0}'.format(goodsId), function(success, data) {
        if (success && $rootScope.GOODS[data.loyalty_id]) {
          updateItemInList($rootScope.GOODS[data.loyalty_id], data);
        }
        callback(success, data);
      });
    };

    /**
     *
     * @param post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GoodsAdd = function(post_data, callback) {
      API.post('/goods', post_data, function(success, data) {
        if (success && $rootScope.GOODS[data.loyalty_id]) {
          updateItemInList($rootScope.GOODS[data.loyalty_id], data);
        }
        callback(success, data);
      });
    };

    /**
     *
     * @param {string} goodsId - Goods ID
     * @param post_data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GoodsEdit = function(goodsId, post_data, callback) {
      API.patch('/goods/{0}'.format(goodsId), post_data, function(success, data) {
        if (success && $rootScope.GOODS[data.loyalty_id]) {
          updateItemInList($rootScope.GOODS[data.loyalty_id], data);
        }
        callback(success, data);
      });
    };

    /**
     * Upload goods photo
     *
     * @param {string} goodsId - Goods ID
     * @param data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UploadGoodsPhoto = function(goodsId, data, callback) {
      API.postImage('/goods/{0}/photo'.format(goodsId), data, function(success, response) {
        callback(success, response);
      });
    };

    /**
     * Delete/Clear goods photo
     *
     * @param {string} goodsId - Goods ID
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeleteGoodsPhoto = function(goodsId, callback) {
      API.delete('/goods/{0}/photo'.format(goodsId), function(success, response) {
        callback(success, response);
      });
    };
    /**
     * Upload goods additional image
     *
     * @param {string} goodsId - Goods ID
     * @param data
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.UploadGoodsAddImage = function(goodsId, data, callback) {
      API.postImage('/goods/{0}/additional_image'.format(goodsId), data, function(success, response) {
        callback(success, response);
      });
    };

    /**
     * Delete goods additional image
     *
     * @param {string} goodsId - Goods ID
     * @param imageId
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.DeleteGoodsAddImage = function(goodsId, imageId, callback) {
      API.del('/goods/{0}/additional_image/{1}'.format(goodsId, imageId), function(success, response) {
        callback(success, response);
      });
    };

    /**
     *
     * @param {requestCallback} callback - The callback that handles the response.
     */
    service.GetServiceTypes = function(callback) {
      API.get('/goods/service_types', function(success, data) {
        callback(success, data);
      });
    };

    return service;
  }

})();
